<router-outlet></router-outlet>
<ngx-spinner type="none" bdColor="rgba(0,0,0,0.8)">
	<app-loader></app-loader>
</ngx-spinner>
<app-server-error *ngIf="showError"></app-server-error>
<app-network-error *ngIf="!networkStatus"></app-network-error>
